const storageModule = require('firebase').storage;
export default storageModule;
